/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiConversionFromJSON, ApiConversionToJSON, } from './ApiConversion';
import { ApiConversionStateLookupTypeFromJSON, ApiConversionStateLookupTypeToJSON, } from './ApiConversionStateLookupType';
import { ApiConversionStateTriggerFromJSON, ApiConversionStateTriggerToJSON, } from './ApiConversionStateTrigger';
export function ApiConversionStateFromJSON(json) {
    return ApiConversionStateFromJSONTyped(json, false);
}
export function ApiConversionStateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'conversion': !exists(json, 'conversion') ? undefined : ApiConversionFromJSON(json['conversion']),
        'conversionId': !exists(json, 'conversionId') ? undefined : json['conversionId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lookup': !exists(json, 'lookup') ? undefined : ApiConversionStateLookupTypeFromJSON(json['lookup']),
        'offline': !exists(json, 'offline') ? undefined : json['offline'],
        'offlineFieldName': !exists(json, 'offlineFieldName') ? undefined : json['offlineFieldName'],
        'preventSubmit': !exists(json, 'preventSubmit') ? undefined : json['preventSubmit'],
        'repeatedSelector': !exists(json, 'repeatedSelector') ? undefined : json['repeatedSelector'],
        'target': !exists(json, 'target') ? undefined : json['target'],
        'targetInnerText': !exists(json, 'targetInnerText') ? undefined : json['targetInnerText'],
        'trigger': !exists(json, 'trigger') ? undefined : ApiConversionStateTriggerFromJSON(json['trigger']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}
export function ApiConversionStateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'conversion': ApiConversionToJSON(value.conversion),
        'conversionId': value.conversionId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'id': value.id,
        'lookup': ApiConversionStateLookupTypeToJSON(value.lookup),
        'offline': value.offline,
        'offlineFieldName': value.offlineFieldName,
        'preventSubmit': value.preventSubmit,
        'repeatedSelector': value.repeatedSelector,
        'target': value.target,
        'targetInnerText': value.targetInnerText,
        'trigger': ApiConversionStateTriggerToJSON(value.trigger),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'value': value.value,
    };
}
